module.exports = require('./head');